import type { SavedServer, StreamServer } from '../types';
import { newId } from '../utils/uuid';

function isoFromMs(ms: number): string {
  try {
    return new Date(ms).toISOString();
  } catch {
    return new Date().toISOString();
  }
}

/** Migrate legacy v1 SavedServer entries to StreamServer v2. */
export function migrateSavedServerToStreamServer(old: SavedServer): StreamServer {
  const now = new Date().toISOString();
  const created = isoFromMs(old.createdAt);

  if (old.type === 'xtream' && old.xtream) {
    return {
      id: old.id,
      name: old.name,
      server: old.xtream.baseUrl.replace(/\/+$/, ''),
      username: old.xtream.username,
      password: old.xtream.password ?? '',
      createdAt: created,
      updatedAt: now,
      sourceKind: 'xtream',
    };
  }
  if (old.type === 'm3u_url' && old.m3uUrl) {
    return {
      id: old.id,
      name: old.name,
      server: old.m3uUrl.playlistUrl,
      username: 'm3u',
      password: '',
      createdAt: created,
      updatedAt: now,
      sourceKind: 'm3u_url',
      m3uEpgUrl: old.m3uUrl.epgUrl,
    };
  }
  if (old.type === 'm3u_file' && old.m3uFile) {
    return {
      id: old.id,
      name: old.name,
      server: 'local-playlist',
      username: 'm3u',
      password: '',
      createdAt: created,
      updatedAt: now,
      sourceKind: 'm3u_file',
      m3uFileContent: old.m3uFile.content,
    };
  }
  return {
    id: old.id,
    name: old.name,
    server: '',
    username: '',
    password: '',
    createdAt: created,
    updatedAt: now,
    sourceKind: 'xtream',
  };
}

export function duplicateStreamServer(s: StreamServer): StreamServer {
  const now = new Date().toISOString();
  return {
    ...s,
    id: newId(),
    name: `${s.name} (copy)`,
    createdAt: now,
    updatedAt: now,
    lastConnectedAt: undefined,
    lastError: undefined,
  };
}
